import React from "react";
import classnames from "classnames";
import { Checkbox } from "@my-scoot/component-library-legacy";
import { useStyles } from "./index.styles";

const ExlyCheckbox = (props) => {
  const classes = useStyles();

  const {
    input = {},
    meta = {},
    onChange,
    label,
    helperNode,
    outerWrapperClassName,
    labelClassName,
    ...rest
  } = props;

  return (
    <div
      className={classnames(classes.root, outerWrapperClassName, {
        // A checked-but-disabled box (e.g. show_at_checkout on a locked
        // offer) is information, not an action — keep it legible instead
        // of letting the legacy 50% disabled fade pass it off as empty.
        [classes.checkedDisabled]: !!(
          rest.disabled &&
          (input.checked ?? input.value)
        ),
      })}
    >
      <Checkbox
        error={meta.error && meta.touched}
        helperText={meta.error && meta.touched ? meta.error : null}
        // NOTE: for final-form boolean checkboxes (Field type="checkbox"
        // with no `value` prop), input.value is ALWAYS undefined — it echoes
        // the Field's `value` prop, not the form state. input.checked is the
        // live boolean (get checked() => !!state.value). Using input.value
        // here made every prefilled-true box render unchecked on open.
        checked={input.checked ?? input.value}
        {...rest}
        autocomplete={"off"}
        onChange={(e) => {
          e.target.value = e.target.checked;
          if (input?.onChange) input.onChange(e);
          if (onChange) {
            onChange(e.target.checked, input.name);
          }
        }}
      />
      <label
        htmlFor={props.id}
        className={classnames(classes.label, labelClassName)}
      >
        {label}
      </label>
      {helperNode}
    </div>
  );
};

export default ExlyCheckbox;
